<template>
	<div>
		<v-container>
			<div v-if="documentId != 0" :class="['text-h5', 'pa-4', 'text-center']">
				{{ $t('titles.editingDocument') }}
			</div>
			<div v-else :class="['text-h5', 'pa-4', 'text-center']">
				{{ $t('titles.newDocument') }}
			</div>
			<v-row>
				<v-col cols="12">
					<InputField
						:readonly="!inEditMode"
						v-model="teacherDocument.name"
						:errorBorder="!teacherDocumentValidation.name"
						:label="'* ' + $t('fields.name')"
					></InputField>
				</v-col>

				<v-col cols="12" style="text-align: center">
					<Upload
						:readonly="false"
						:showDelete="false"
						v-model="teacherDocument.uploaded_file"
						:label="'* ' + $t('fields.file')"
					></Upload>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row class="text-center">
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick"> {{ $t('buttons.save') }} </v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import TeacherDocument from '../../../models/TeacherDocument';
import InputField from '../../trinkets/InputField';
import Upload from '../../trinkets/Upload';

export default {
	name: 'Document',
	components: { InputField, Upload },
	props: {
		documentId: [String, Number],
		inEditMode: Boolean,
	},
	emits: ['close', 'reloadData'],
	data() {
		return {
			teacherDocumentValidation: new TeacherDocument({}, true),
			teacherDocument: new TeacherDocument({ id: 0, teacher_id: this.$route.params.id }),
		};
	},
	computed: {},
	watch: {
		documentId() {
			this.getDocument();
		},
	},
	mounted() {
		this.getDocument();
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		getDocument() {
			var vm = this;
			if (this.documentId != 0) {
				this.$APICall(
					'get',
					'teacher-document/' + this.documentId,
					{},
					(data, success) => {
						if (success) {
							vm.teacherDocument = data;
						}
					},
					false
				);
			} else {
				this.teacherDocument = new TeacherDocument({ id: 0, teacher_id: this.$route.params.id });
			}
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (this.teacherDocument.name == null || this.teacherDocument.name == '') {
				success = false;
				errorMessages += this.$t('alerts.nameMissing') + '<br />';
				this.teacherDocumentValidation.name = false;
			} else {
				if (this.teacherDocument.name.length > 100) {
					this.teacherDocumentValidation.name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.name'))
							.replace('%length%', '100') + '<br />';
				} else {
					this.teacherDocumentValidation.name = true;
				}
			}

			if (!this.teacherDocument.uploaded_file.upload_id) {
				success = false;
				errorMessages += this.$t('alerts.fileMissing') + '<br />';
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.documentId) {
					action = 'put';
					addition = '/' + vm.documentId;
				}
				this.$APICall(action, 'teacher-documents' + addition, this.teacherDocument, (data, success) => {
					if (success) {
						if (vm.documentId == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						this.teacherDocument = new TeacherDocument({ id: 0, teacher_id: this.$route.params.id });
						vm.$emit('reloadData');
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
					this.$emit('close');
				});
			}
		},
	},
};
</script>
